// V3 JOB BASIC INFO ******************************************************************************
// pathname: /v3/job-basic-info/{jobSlug}
// ************************************************************************************************
import { useSwrApi, ApiJobBasicInfo, ApiJobBasicInfoOk } from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch the basic info for a job.
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param serverSideData - the server side data
 */
export const useSwrJobBasicInfo = (jobSlug: string, locale = 'ro', serverSideData?: ApiJobBasicInfo) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSwrApi<ApiJobBasicInfoOk>({
    url: `/v3/job-basic-info/${jobSlug}`,
    locale,
    serverSideData,
    apiOptions: {
      dedupingInterval: 1000 * 60 * 5, // 5 minutes
    },
  });

  // Return data
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
